import React from "react";

export function ThumbsUp({ isActive }: { isActive?: boolean }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8L13.5 2L15.35 3.85L14.05 8H22V12.4L17.85 21H6H2V8H6ZM16.5 19H8V8.85L12.85 5.5L11.5 10H20V12L16.5 19ZM4 10H6V19H4V10Z"
        fill={isActive ? "#364ef7" : "#312F4F"}
      />
    </svg>
  );
}

export function ThumbsDown({ isActive }: { isActive?: boolean }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 16L10.5 22L8.65 20.15L9.95 16L2 16L2 11.6L6.15 3L18 3L22 3L22 16L18 16ZM7.5 5L16 5L16 15.15L11.15 18.5L12.5 14L4 14L4 12L7.5 5ZM20 14L18 14L18 5L20 5L20 14Z"
        fill={isActive ? "#D23718" : "#312F4F"}
      />
    </svg>
  );
}
